import IArticle from "@/Models/Article/IArticle";
import IBlogDetails from "@/Models/Blog/IBlogDetails";
import IBlogPost from "@/Models/Blog/IBlogPost";
import IFreelanceJob from "@/Models/Work/IFreelanceJob";
import IPackage from "@/Models/Work/IPackage";
import IPackageList from "@/Models/Work/IPackageList";
import IProfessionalJob from "@/Models/Work/IProfessionalJob";
import SteinClient from "@/Utils/Data/SteinClient";
import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
const stein: any = SteinClient.getInstance().steinStore;

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    IsDark: false,
    AppVersion: null,
    BlogPosts: [],
    BlogDetails: [],
    Articles: [],
    FreelanceWork: [],
    Packages: [],
    ProfessionalWork: []
  },
  getters: {
    IsItDark: (state): boolean =>state.IsDark,
    GetAllBlogPosts: (state): IBlogPost[] => state.BlogPosts,
    GetAllArticles: (state): IArticle[] => state.Articles,
    GetPostDetailsById: (state) => (id: string) => {
      return state.BlogDetails.find((detail: IBlogDetails) => detail.Id === id);
    },
    GetAllFreelanceWork: (state): IFreelanceJob[] => state.FreelanceWork,
    GetAllProfessionalWork: (state): IProfessionalJob[] => state.ProfessionalWork,
    GetSplitPackages: (state): IPackageList[] => {
      const list: IPackageList[] = [];
      state.Packages.forEach((e: IPackage) =>{
        if (!list.find((j) => j.Language === e.Language))
        {
          list.push({Language: e.Language, Packages: []});
          list.find((k) => k.Language === e.Language)?.Packages.push(e);
        }
        else
        {
          list.find((j) => j.Language)?.Packages.push(e);
        }
      });

      return list;
    },
  },
  mutations: {
    IsDark: (state, isDark: boolean): void => {
      state.IsDark = isDark;
    },
    AppVersion: (state, appVer): void => {state.AppVersion = appVer;},
    BlogPosts: (state, posts): void => {state.BlogPosts = posts;},
    BlogDetails: (state, details): void => {state.BlogDetails = details;},
    Articles: (state, articles): void => {state.Articles = articles;},
    FreelanceWork: (state, freelanceWorks): void => {state.FreelanceWork = freelanceWorks;},
    Packages: (state, packages): void => {state.Packages = packages;},
    ProfessionalWork: (state, professionalWorks): void => {state.ProfessionalWork = professionalWorks;},
  },
  actions: {
    SetAppVersion: ({commit}, appVer): void => {commit("AppVersion", appVer);},
    SetArticles: ({commit}, articles): void => {commit("Articles", articles);},
    SetBlogPosts: ({commit}, posts): void => {commit("BlogPosts", posts);},
    SetBlogDetails: ({commit}, details): void => {commit("BlogDetails", details);},
    SetFreelanceWork: ({commit}, freelanceWorks): void => {commit("FreelanceWork", freelanceWorks);},
    SetPackages: ({commit}, packages): void => {commit("Packages", packages);},
    SetProfessionalWork: ({commit}, professionalWorks): void => {commit("ProfessionalWork", professionalWorks);},
    SetIsDark: ({commit}, isDark: boolean): void => {commit("IsDark", isDark);},
    InitializeApp: async function({dispatch}: any): Promise<void>
    {
      const appVer: any = await stein.read("AppVersion").then((data: any) => data);
      const aVer: number = parseInt(appVer[0].appVersion, 10);
      if (aVer !== this.state.AppVersion || this.state.AppVersion === 0)
      {
        await dispatch("FetchBlogPosts");
        await dispatch("FetchBlogDetails");
        await dispatch("FetchArticles");
        await dispatch("FetchFreelanceWork");
        await dispatch("FetchProfessionalWork");
        await dispatch("FetchPackages");
        dispatch("SetAppVersion", aVer);
      }
    },
    FetchBlogPosts: async function({dispatch}: any): Promise<void>
    {
      const posts: IBlogPost[] = await stein.read("BlogPosts").then((data: IBlogPost[]) => data);
      dispatch("SetBlogPosts", posts);
    },
    FetchBlogDetails: async function({dispatch}: any): Promise<void>
    {
      const details: IBlogDetails[] = await stein.read("BlogDetails").then((data: IBlogDetails[]) => data);
      dispatch("SetBlogDetails", details);
    },
    FetchArticles: async function({dispatch}: any): Promise<void>
    {
      const articles: IArticle[] = await stein.read("Articles").then((data: IArticle[]) => data);
      dispatch("SetArticles", articles);
    },
    FetchFreelanceWork: async function({dispatch}: any): Promise<void>
    {
      const freelanceWorks: IFreelanceJob[] = await stein.read("FreelanceWork").then((data: IFreelanceJob[]) => data);
      dispatch("SetFreelanceWork", freelanceWorks);
    },
    FetchProfessionalWork: async function({dispatch}: any): Promise<void>
    {
      const professionalWorks: IProfessionalJob[] = await stein.read("ProfessionalExperience")
        .then((data: IProfessionalJob[]) => data);
      dispatch("SetProfessionalWork", professionalWorks);
    },
    FetchPackages: async function({dispatch}: any): Promise<void>
    {
      const packages: IPackage[] = await stein.read("Packages")
        .then((data: IPackage[]) => data);
      dispatch("SetPackages", packages);
    }
  },
  modules: {}
});
